import { MobileFab } from "@/components/common/MobileFab";
import { MobileSpeedDial, type SpeedDialAction } from "@/components/common/MobileSpeedDial";

interface PageMobileActionsProps {
  actions: SpeedDialAction[];
  className?: string;
}

export function PageMobileActions({ actions, className }: PageMobileActionsProps) {
  if (actions.length === 0) return null;

  if (actions.length === 1) {
    const action = actions[0];
    const Icon = action.icon;
    return (
      <MobileFab
        icon={Icon}
        label={action.label}
        onClick={action.onClick}
        className={className}
      />
    );
  }

  return <MobileSpeedDial actions={actions} className={className} />;
}
